import { User } from '@app/shared/models';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { Log } from "ng2-logger";
import { UserBusinessType } from '@app/shared/models/enums/user-business-type.enum';

@Component({
    selector: 'app-users-table',
    templateUrl: 'users-table.component.html',
    styleUrls: ['users-table.component.scss']
})
export class UsersTableComponent {
    _logger = Log.create(UsersTableComponent.name);

    @Input() users = new Array<User>();
    @Input() userStates = new Array<any>();
    @Input() userBusinessTypeFilters = new Array<any>();
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<User>();

    constructor() {
    }

    onPageChange(tableConfig: TableConfig) {
        this._logger.info("onPageChange::", tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info("onSortChange::", tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info("onFilterChange::", tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onRowClick(user: User) {
        this._logger.info("onRowClick::", user);
        this.rowClick.emit(user);
    }

    businessTypeLabel(user: User) {
        switch (user.userBusinessType) {
            case UserBusinessType.TechnicalProductionUser:
                return 'admin.users.table.rows.userBusinessType.technicalProductionUser';
            case UserBusinessType.TechnicalToolManagementUser:
                return 'admin.users.table.rows.userBusinessType.technicalToolManagementUser';
            case UserBusinessType.EmployeeUser:
            default:
                return 'admin.users.table.rows.userBusinessType.employeeUser';
        }
    }
}
